<template>
    <Mz-Dialog class="dialog" :title="title" width="3222px" :visible.sync="visible" @handleClose="handleClose">
        <div slot="content" class="flx-cs main" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)">
            <div class="process">
                <ul class="flx-bc types">
                    <li v-for="item in data" :key="item.type" @click="content=item.content">{{item.type}}</li>
                </ul>
                <div class="flx-bs box">
                    <div class="lists" v-for="box in data" :key="box.type">
                        <div class="part" v-for="(part,index) in box.data" :key="index">
                            <ul>
                                <li v-for="item in part.data" :key="item.name" @click="content=item.content">{{item.name}}</li>
                            </ul>
                            <span class="use" v-if="part">{{part.use}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content" v-if="content">
                <div class="box" v-html="content"></div>
            </div>
        </div>
    </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
    export default {
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            data: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                loading: false,
                content: '',
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            handleClose(){
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="less" scoped>
@import '@/styles/common';
.main{
    padding: 118px 136px 160px 120px;
    .process{
        width: 1788px;
        height: 1368px;
        background: url("../../assets/img_liucheng.png") no-repeat;
        background-size: 100% 100%;
        .types{
            li{
                width: 596px;
                height: 162px;
                line-height: 162px;
                text-align: center;
                font-size: 48px;
                cursor: pointer;
            }
        }
        .box{
            margin-top: 63px;
            .lists{
                padding: 0 57px 0 51px;
                .part{
                    position: relative;
                    padding: 52px 0;
                    .use{
                        position: absolute;
                    }
                    li{
                        display: flex;
                        width: 330px;
                        height: 120px;
                        justify-content: center;
                        align-items: center;
                        border-radius: 24px;
                        background: #0A3E7A;
                        cursor: pointer;
                    }
                }
            }
            .lists:nth-child(1){
                .part{
                    li+li{
                        margin-top: 27px;
                    }
                }
                .part:nth-child(1){
                    padding: 72px 0 102px;
                    .use{
                        left: 195px;
                        bottom: 20px;
                    }
                }
                .part:nth-child(2){
                    padding-bottom: 123px;
                    .use{
                        left: 195px;
                        bottom: -10px;
                    }
                }
                .part:nth-child(3){
                    .use{
                        right: -234px;
                        top: 0;
                    }
                }
            }
            .lists:nth-child(2){
                margin-left: 225px;
                .part{
                    li+li{
                        margin-top: 33px;
                    }
                    .use{
                        right: -258px;
                        top: 465px;
                    }
                }
            }
            .lists:nth-child(3){
                margin-left: 249px;
                margin-top: 87px;
                .part{
                    padding-top: 60px;
                    li+li{
                        margin-top: 48px;
                    }
                }
                .part:nth-child(1){
                    padding-bottom: 123px;
                }
            }
        }
    }
    .content{
        width: 1032px;
        height: 1368px;
        border: 3px solid #375193;
        background: #000;
        padding: 80px 0 80px 80px;
        margin-left: 144px;
        .box{
            max-height: 100%;
            overflow: auto;
            font-size: 42px;
            padding-right: 80px;
        }
    }
}
</style>